import Fullscreen from "./fullscreen";
import LayoutDetails from "./layoutDetails";
import Pip from "./pip";
import Quadbox from "./quadbox";
import Triple from "./triple";

const availableLayouts: LayoutDetails[] = [Fullscreen, Pip, Triple, Quadbox];
export default availableLayouts;